import type { InputDropdownOption } from '@interxfi/design-system/components/input/shared/dropdown/input-dropdown';
import type { TFunction } from '@interxfi/translation';
import { IsoV1Country, IxcRegistrationV1UsState } from '@interxfi/types/generated/api';
import { getIntlDisplayNameFormat } from '@interxfi/utilities/intl/display-name';
import { sortByKey } from '@interxfi/utilities/sort';
import { enumToOptions } from './enum';

export function buildCountryOptions(
  locale: string | undefined = 'en-US',
  countries: IsoV1Country[] | undefined = Object.values(IsoV1Country),
): InputDropdownOption<IsoV1Country>[] {
  const regionNamesForLocale = getIntlDisplayNameFormat(locale, { type: 'region' });

  return sortByKey(
    (countries || []).reduce((accum, country) => {
      try {
        accum.push({
          value: country,
          label: regionNamesForLocale.of(country) || country,
        });
      } catch {}

      return accum;
    }, [] as InputDropdownOption<IsoV1Country>[]),
    (x) => x.label,
  );
}

// This is for future-state with translatable names
export function buildStateOptions(t: TFunction, country: IsoV1Country | undefined = IsoV1Country.Us): InputDropdownOption[] {
  switch (country) {
    case IsoV1Country.Us:
      return enumToOptions(t, IxcRegistrationV1UsState, 'ixcRegistrationV1:enum.IxcRegistrationV1UsState', true);
    default:
      return [];
  }
}
